import { useState } from "react";
import { format } from "date-fns";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { AlertDialog, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { api, formatApiError, formatTime } from "@/lib/api";

export const DeleteAppointmentDialog = ({ appt, onClose, onDeleted }) => {
  const [loading, setLoading] = useState(false);

  const confirm = async () => {
    setLoading(true);
    try {
      await api.delete(`/admin/appointments/${appt.id}`);
      toast.success("Appointment deleted");
      onClose();
      onDeleted();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AlertDialog open={!!appt} onOpenChange={(o) => { if (!o) onClose(); }}>
      <AlertDialogContent data-testid="delete-appointment-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Delete this appointment?</AlertDialogTitle>
          <AlertDialogDescription>
            {appt && <>{appt.name} · {format(new Date(`${appt.date}T00:00:00`), "d MMM yyyy")} at {formatTime(appt.time)} · {appt.reference}. </>}
            This permanently removes it and frees the time slot. This cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="delete-appointment-cancel-btn">Keep it</AlertDialogCancel>
          <Button variant="destructive" onClick={confirm} disabled={loading} data-testid="delete-appointment-confirm-btn">
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Delete
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
